// Tradein Badge by salvarez

var AppBadge = {
  url: {
    CreatePriceRule: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/CreatePriceRule'
  },
  img: {
    imgBadge: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/Recurso_10_1.5x.png?v=1676584515',
    remove: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/remove.png?v=1676586725',
  },
  init: function() {
    AppBadge.event();
    AppBadge.addTradeInBadge();
  },
  event: function() {
    $( "body" ).on( "click", ".removeTradeIn" , AppBadge.removeTradeIn);
  },
  addTradeInBadge: function(){
    $("ul.cartitems--list li").each(function() {
      let dataCartitemId = $(this).attr("data-cartitem-id");
      if( dataCartitemId === localStorage.getItem('variantId') ){
          let elem = $(this).find(".cart-item--content-price");
        $('<h4 class="tradeInBadge" style="font-size:14px"><img src="' + AppBadge.img.imgBadge + '" style="width:100px;vertical-align: middle;margin-right: 15px;"/><span style="color: #fff;background-color: #1878b9;padding:3px;"> Ahorras $' + new Intl.NumberFormat().format(localStorage.getItem('discountValue')) + '</span><span><a class="removeTradeIn" href="#" style="text-decoration: none;color: red;"><img src="' + AppBadge.img.remove + '" style="width: 16px;vertical-align: middle;margin-left: 20px;"/> Quitar</a></span></h4>').insertAfter(elem);
      }
    });
  },
  removeTradeIn: function(){
    if (confirm("¿Seguro que deseas quitar el Tradein?") == true) {
      var ruleStorage = "remove-" + localStorage.getItem("ruleId");
      const article = { priceRuleTitle: "Remove Tradein", value: "0", productId: "0", ruleID: ruleStorage };
      axios.post(AppBadge.url.CreatePriceRule, article)
      .then((response) => {
        console.log("Remove response:", response);
        localStorage.removeItem('ruleId');
        localStorage.removeItem('discountCode');
        localStorage.removeItem('variantId');
        localStorage.removeItem('discountValue');
        location.reload();
       })
      .catch(error => {
        console.log("error : ", error);
      });
      const userEmail = SECOMAPP.customer.email;
        const userFirstName = SECOMAPP.customer.first_name;
        const userLastName = SECOMAPP.customer.last_name;
        const sku = $('span[data-product-sku]').text().trim();
        
        const objeto = {
          email: userEmail !== null ? `${userEmail}`: null,
          full_name: userEmail !== null ? `${userFirstName} ${userLastName}`: null,
          product_sku: sku,
          trade_model: null,
          id_action: 3
        };
        axios.post(App.url.CreateHistoryLog, objeto)
          .then(response => {
              console.log('Log registrado:', response.data);
          })
          .catch(error => {
              console.error('Error al registrar el log:', error);
          });
    } else {
      console.log("No se removió el Tradein")
    };
    return false;
  }
}

const open = window.XMLHttpRequest.prototype.open;
function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      console.log("Cambio en el cart");
        setTimeout(function() { 
          AppBadge.addTradeInBadge();
      }, 1000);
    }
  });
  return open.apply(this, arguments);
}
window.XMLHttpRequest.prototype.open = openReplacement;

$(document).ready(AppBadge.init)